import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: "Just Hi",
    description: "A simple page that says hi.",
    url: getOrigin()
}

// Slug of the item in the CMS "pages" collection that holds the home page content.
export const HOME_PAGE_SLUG = 'home'
